import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { Form, checkBox, selectBox } from "trader.ts/ui.forms";
import { checkAllCasesHandled } from "trader.ts/utils";
import * as style from "../../../styles/style.css.classes";
import { renderSaveButton } from "../../client/savebutton";
import * as routes from "../../routes";

export function render(
  opts:
    | {
        tag: "already_connected";
        alwaysShowWireInstructions: boolean;
      }
    | {
        tag: "mollie_profile";
        profiles: { id: string; name: string }[];
      }
    | {
        tag: "moneybird_administration";
        administrations: { id: string; name: string }[];
      },
): HTMLElement | HTMLElement[] {
  if (opts.tag === "already_connected") {
    return renderAlreadyConnectedSection(opts);
  } else if (opts.tag === "mollie_profile") {
    return renderMollieProfileFormSection(opts.profiles);
  } else if (opts.tag === "moneybird_administration") {
    return renderMoneybirdAdministrationFormSection(opts.administrations);
  } else {
    return checkAllCasesHandled(opts);
  }
}

function renderAlreadyConnectedSection(opts: {
  alwaysShowWireInstructions: boolean;
}) {
  const form = new Form({})
    .addField("alwaysShowWireInstructions", [], () =>
      checkBox({
        initialVal: opts.alwaysShowWireInstructions,
        class: style.checkbox,
        label: "Toon naast de betaalknop ook nog de overschrijvingsinstructies in de inschrijvingsemails",
      }),
    )
    .build();
  return (
    <div>
      <section>
        <b>
          {"Je Mollie account is geconnecteerd met de account van Classy.school!"}
        </b>
      </section>
      <hr />
      {form.render()}
      <div style="text-align: right">
        {renderSaveButton({
          formS: form.s,
          save: (form) =>
            rpc(routes.saveAlwaysShowWireInstructionsSpec, undefined, form),
          reload: true,
        })}
      </div>
    </div>
  );
}
function renderMollieProfileFormSection(
  profiles: { id: string; name: string }[],
): HTMLElement | HTMLElement[] {
  const form = new Form({})
    .addField("profile", [], () =>
      selectBox({
        values: profiles,
        initial: profiles[0],
        show: (p) => p.name,
      }),
    )
    .build();

  const text = "Je Mollie account is geconnecteerd met de account van Classy.school! Selecteer het Mollie profiel dat je wilt gebruiken om betalingen mee uit te voeren. ";
  return (
    <div>
      <section>{text}</section>
      <section>{form.render()}</section>
      <div style="text-align: right">
        {renderSaveButton({
          formS: form.s,
          save: (form) =>
            rpc(routes.saveMollieProfileSpec, undefined, form.profile),
          reload: () => (document.location = routes.config_mollieRoute.link()),
        })}
      </div>
    </div>
  );
}
function renderMoneybirdAdministrationFormSection(
  administrations: { id: string; name: string }[],
): HTMLElement | HTMLElement[] {
  const form = new Form({})
    .addField("administration", [], () =>
      selectBox({
        values: administrations,
        initial: administrations[0],
        show: (p) => p.name,
      }),
    )
    .build();

  const text = "Selecteer de Moneybird administratie die je wilt gebruiken";
  return (
    <div>
      <section>{text}</section>
      <section>{form.render()}</section>
      <div style="text-align: right">
        {renderSaveButton({
          formS: form.s,
          save: (form) =>
            rpc(
              routes.saveMoneybirdAdministrationSpec,
              undefined,
              form.administration,
            ),
          reload: () =>
            (document.location = routes.config_accountingsoftwareRoute.link()),
        })}
      </div>
    </div>
  );
}
